import type { CreateProductVariantDto } from "../../../../api";

/**
 * The set of axes we let sellers compose variants from.
 * Adding a new axis is a four-step change:
 *   1. add it here,
 *   2. add it to AXIS_DTO_FIELD,
 *   3. add a hook for it in OptionCard's per-axis switch,
 *   4. teach the read-only details page to surface it.
 */
/**
 * Variant axes correspond to real Odoo product.attribute rows. Selecting one of
 * these on the seller form actually generates Odoo variants via attribute_line_ids.
 *
 * Screen Size and Resolution are deliberately NOT in here — they're template-level
 * specs (one value per product, set in BasicInfoSection, written to product.template).
 */
export type NonEmptyVariantAxis = "RAM" | "Storage" | "Color" | "CPU";

export type VariantOptionAxis = "" | NonEmptyVariantAxis;

export const VARIANT_AXES: NonEmptyVariantAxis[] = [
  "RAM",
  "Storage",
  "Color",
  "CPU",
];

/** Per-axis DTO field on CreateProductVariantDto (and ProductVariantResponseDto). */
export const AXIS_DTO_FIELD: Record<NonEmptyVariantAxis, keyof CreateProductVariantDto> = {
  "RAM": "ramValueId",
  "Storage": "storageValueId",
  "Color": "colorValueId",
  "CPU": "cpuValueId",
};
